import { LogoutOptions } from "@auth0/auth0-react";
import { CompareArrows, ExitToApp, Person } from "@mui/icons-material";
import { Box, Button, ButtonGroup, Divider, Stack, Typography } from "@mui/material";
import { MouseEvent, PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { IClient } from "../../../../../Typings/Client";
import { IUser } from "../../../../../Typings/User";
import { MessagingQuotaButton } from "./MessagingQuotaButton";
import { useUserProfileStore } from "../../../../../State/Stores/UserProfileStore";
import { useSelectedClient } from "../../../../../Queries/ClientQueries";

export const UserMenuButtons = ({
  user,
  clients,
  handleCloseUserMenu,
  handleOpenClientsMenu,
  logout,
}: PropsWithChildren<{
  user: IUser;
  clients: IClient[];
  handleCloseUserMenu: (event: MouseEvent<HTMLElement>) => void;
  handleOpenClientsMenu: (event: MouseEvent<HTMLElement>) => void;
  logout: (options?: LogoutOptions) => void;
}>) => {
  const { data: selectedClient } = useSelectedClient();
  const displayName = user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.nickname;
  const { profile } = useUserProfileStore();

  return (
    <Box
      sx={{
        "& .MuiButton-root": {
          justifyContent: "flex-start",
          fontWeight: "normal",
          color: "text.primary",
          px: 3,
          py: 1,
          textTransform: "none",
        },
      }}
    >
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "0.25em",
          px: 3,
          py: 1,
        }}
      >
        <Typography
          data-test="profile-menu-mobile-username"
          variant="subtitle1"
          sx={{
            width: 1,
            textAlign: "left",
            fontWeight: "bold",
            lineHeight: 1,
          }}
        >
          {displayName}
        </Typography>
        <Typography
          data-test="profile-menu-mobile-selectedclient"
          variant="subtitle2"
          sx={{ fontWeight: "normal", lineHeight: 1 }}
        >
          {selectedClient?.clientName}
        </Typography>
      </Box>
      <Divider />
      <ButtonGroup variant="text" orientation="vertical" fullWidth={true}>
        <Button
          data-test={"profile-menu-page-link"}
          onClick={handleCloseUserMenu}
          component={Link}
          to="/profile"
          startIcon={<Person fontSize="small" />}
          sx={{
            border: "none !important",
          }}
        >
          <Stack direction="column">
            <Typography>Profile</Typography>
            <Typography fontSize={10} variant="caption">
              {profile.timezoneId}
            </Typography>
          </Stack>
        </Button>
        {clients.length > 1 ? (
          <Button
            data-test={"profile-menu-switch-client"}
            aria-expanded={false}
            aria-controls="menu-clientselector"
            onClick={handleOpenClientsMenu}
            startIcon={<CompareArrows fontSize="small" />}
            sx={{
              border: "none !important",
            }}
          >
            Switch Client
          </Button>
        ) : null}
        <MessagingQuotaButton />
      </ButtonGroup>
      <Divider />
      <Button
        onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
        data-test={"profile-menu-logout"}
        startIcon={<ExitToApp fontSize="small" />}
      >
        Logout
      </Button>
    </Box>
  );
};
